import { request } from '@/utils/ajax';

export type SearchResultType = 'Project' | 'ResidentialUnit' | 'CatalogProduct' | 'User';
export interface SearchResult {
    projectId: number;
    objectId: number;
    objectType: SearchResultType;
    displayName: string;
    objectInfo: any;
    imageId: number | null;
    residentialUnitName: string | null;
}

export function globalSearch(projectId: number, query: string): Promise<SearchResult[]> {
    return request(`api/search`, { query: { projectId, q: query } }).then((x) => x.json());
}

export function searchByFields<T>(data: T[] | null, searchText: string, fields: string[]): T[] {
    if (data && data?.length && fields.length && searchText.length) {
        searchText = searchText.toLowerCase();
        return data.filter((x) =>
            fields?.some((field) => {
                // Check if field is an array to include in search
                if (field.includes('[].')) {
                    const [array, arrayField] = field.split('[].');
                    return x[array].some((y) => {
                        return y[arrayField].toLowerCase().match(searchText);
                    });
                }

                return x[field]?.toLowerCase()?.includes(searchText);
            })
        );
    }
    return data ?? [];
}
